export const CHANGE_SEARCHFIELD_CUSTOMERS = "CHANGE_SEARCHFIELD_CUSTOMERS";

export const REQUEST_CUSTOMERS_PENDING = "REQUEST_CUSTOMERS_PENDING";
export const REQUEST_CUSTOMERS_SUCCESS = "REQUEST_CUSTOMERS_SUCCESS";
export const REQUEST_CUSTOMERS_FAILED = "REQUEST_CUSTOMERS_FAILED";
export const GET_CUSTOMER_PROFILE = "GET_CUSTOMER_PROFILE";
export const GET_CUSTOMER_PROFILE_ERROR = "GET_CUSTOMER_PROFILE_ERROR";
export const EDIT_CUSTOMER_PROFILE_SUCCESS = "EDIT_CUSTOMER_PROFILE_SUCCESS";
